module.exports = __webpack_public_path__ + "img/35.575dc1a4.jpeg";